import type { LiveState } from '@models/api';
import { BigScreenJoin } from './BigScreenJoin';
import { BigScreenQuestion } from './BigScreenQuestion';
import { BigScreenRemoved } from './BigScreenRemoved';
import { BigScreenResults } from './BigScreenResults';
import { BigScreenStage } from './BigScreenStage';

export interface BigScreenProps {
  state: LiveState;
  /** E9b: three failed reads in a row; the last state stays. */
  reconnecting?: boolean;
}

/**
 * The big screen for one live state: B1/B1b (join), B2/B2c (the open question), B3/B3b (results), E8b
 * (removed). Display only: the author's controls (`BigScreenAuthorBar`, `BigScreenPagingBar`) are drawn outside
 * the stage, so the room sees the same layout whoever is signed in. Drawn on a scaled 1280×720 stage, so the host
 * view's preview (FE-L1b) can reuse it in any box.
 */
export function BigScreen({ state, reconnecting = false }: BigScreenProps) {
  return <BigScreenStage>{renderState(state, reconnecting)}</BigScreenStage>;
}

const renderState = (state: LiveState, reconnecting: boolean) => {
  if (state.removed) return <BigScreenRemoved state={state} />;
  if (state.live_state === 'ended') {
    return <BigScreenResults state={state} reconnecting={reconnecting} />;
  }
  if (state.live_state === 'live' && state.current_position !== null && state.question) {
    return (
      <BigScreenQuestion state={state} question={state.question} reconnecting={reconnecting} />
    );
  }
  return <BigScreenJoin state={state} reconnecting={reconnecting} />;
};
